<div class="wizard-step-container">
  <div class="wizard-step-header">
    <h1 class="wizard-step-title" role="heading" aria-level="1">{{title}}</h1>
    <p class="wizard-step-subtitle" role="heading" aria-level="2">
      <span *ngIf="isEnglish">{{subtitleBeginning}}<strong>{{subtitleMiddle}}</strong>{{subtitleEnd}}</span>
      <span *ngIf="!isEnglish">{{i18nSubtitle}}</span>
    </p>
  </div>
  <fieldset [attr.aria-label]="title">
    <div class="columns is-multiline is-mobile is-centered is-gapless wizard-tile-wrapper-container">
      <div
        *ngFor="let needToRunOption of needToRunOptions; index as i"
        class="column is-full-mobile is-3-tablet is-2-desktop">
        <app-wizard-tile
          [index]="i"
          [selectionType]="'checkbox'"
          [currentStepName]="analyticsStepName"
          [wizardOption]="needToRunOption"
          [isSelected]="needToRunOption.isSelected"
          [isAlignTextLeft]="true"
          (onSelectEvent)="onSelect($event)"></app-wizard-tile>
      </div>
    </div>
  </fieldset>
  <app-wizard-navigation
    [currentStepName]="analyticsStepName"
    [currentStepNumber]="stepNumber"
    [disableContinueButton]="isContinueBtnDisabled"
    [previousStepRoute]="'/primary-use'"
    [nextStepRoute]="'/use-case'"></app-wizard-navigation>
</div>
<app-progress-bar [step]="currentStep" [stepNumber]="stepNumber"></app-progress-bar>
